module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All","saving_text":"Generating","success_text":"Report generated","default_error_text":"There was a problem generating the report","sort":"Sort Order"},"fr":{"all":"All","saving_text":"Generating","success_text":"Report generated","default_error_text":"There was a problem generating the report","sort":"Sort Order"}}')
  delete Component.options._Ctor
}
